import React, { useState } from "react";
import PropTypes from "prop-types";
import { RadioButton, RadioGroup } from "Components/Base/Inputs/Radio";
import { Button } from "Components/Base/Inputs/Button";
import { Grid } from "Components/Base/Layout/Grid";
import Modal from "lib/components/modalPortal";
import InputLabelSelect from "Components/Fragment/InputLabelSelect";
import { FormControl } from "Components/Base/Inputs/FormControl";
import { FormControlLabel } from "Components/Base/Inputs/FormControlLabel";

const modalStyle = {
  overflowY: "auto",
  movable: false,
  zIndex: 1001,
};

const radios = {
  replace: true,
  add: false,
};

const CopyChecklist = (props) => {
  const { languageContext, activitiesToCopyFrom } = props;
  const [replace, setType] = useState(false);
  const [selectedId, setSelectedId] = useState(
    activitiesToCopyFrom[0]?.checklistId || null,
  );

  function setChecklist(id) {
    setSelectedId(id);
  }

  const copyClickHandler = () => props.onCopyChecklist(selectedId, replace);

  return (
    <Modal
      initiallyOpen
      title={languageContext("copytasksfromotheractivity")}
      dialogStyles={modalStyle}
      close={props.onCancel}
    >
      <div className="column flex-1 bgColor-6">
        <InputLabelSelect
          label={languageContext("choosechecklistfromactivity")}
          onChange={(e) => setChecklist(e.target.value)}
          selectValue={selectedId}
          menuItems={activitiesToCopyFrom.map((item) => {
            return {
              value: item.checklistID,
              title: item.activityTitle,
            };
          })}
        />
        <br />
        <FormControl component="fieldset">
          <RadioGroup
            value={replace ? radios.replace : radios.add}
            onChange={(e) => setType(e.target.value === "true" ? true : false)}
          >
            <FormControlLabel
              value={radios.add}
              control={<RadioButton />}
              label={languageContext("addtasks")}
            />
            <FormControlLabel
              value={radios.replace}
              control={<RadioButton />}
              label={languageContext("replacetasks")}
            />
          </RadioGroup>
        </FormControl>
        <br />
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <Button
              onClick={copyClickHandler}
              label={languageContext("save")}
            />
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              color="secondary"
              onClick={props.onCancel}
              label={languageContext("cancel")}
            />
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

CopyChecklist.propTypes = {
  languageContext: PropTypes.func.isRequired,
  activitiesToCopyFrom: PropTypes.array,
};

CopyChecklist.defaultProps = {
  activitiesToCopyFrom: [],
  languageContext: () => "",
};

export default CopyChecklist;
